// extracted by mini-css-extract-plugin
export default {"slider":"TopSlider__slider--slots-sOxPJ","button":"TopSlider__button--slots-RXmcK"};